(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const items = document.querySelectorAll('.menu-drawer li');
  let targetItem = null;

  items.forEach(li => {
    const link = li.querySelector(':scope > a, :scope > summary');
    if (link && link.textContent.trim().toUpperCase() === "PRÊT À PORTER") {
      targetItem = li;
    }
  });

  if (!targetItem) return;

  targetItem.classList.add('pret-a-porter');
  const link = targetItem.querySelector(':scope > a, :scope > summary');
  const sub  = targetItem.querySelector(':scope > ul, :scope > .submenu, :scope > nav > ul');
  if (link && sub) {
    sub.classList.add('submenu');

    // ⬇ Insertion de l’icône SVG
    if (!link.querySelector('.pret-chevron')) {
      const chev = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      chev.setAttribute("class", "pret-chevron");
      chev.setAttribute("viewBox", "0 0 24 24");
      chev.setAttribute("fill", "none");
      chev.setAttribute("stroke", "currentColor");
      chev.setAttribute("stroke-width", "2");
      chev.setAttribute("stroke-linecap", "round");
      chev.setAttribute("stroke-linejoin", "round");
      chev.innerHTML = `<polyline points="6 9 12 15 18 9"/>`; // chevron down
      link.appendChild(chev);
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      targetItem.classList.toggle('is-open');
    });
  }
})();
